export const getHeightAndWidthFromDataUrl = (dataURL: string): Promise<{ height: number; width: number }> =>
  new Promise((resolve) => {
    const img = new Image();

    img.onload = () => {
      resolve({
        height: img.height,
        width: img.width,
      });
    };

    img.onerror = () => resolve({ height: 0, width: 0 });

    img.src = dataURL;
  });

export const parseURLFromHTML = (html: string) => {
  const urlRegex = /<[^>]+(?:href|src)=["']([^"']+)["'][^>]*>/i;
  const match = html.match(urlRegex);
  return match ? match[1] : null;
};
